module.exports = __webpack_public_path__ + "img/Mozambique.d5ea00fd.svg";